import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AnalyticsRoot } from './components/AnalyticsRoot';
import { ErrorBoundary } from './components/error/ErrorBoundary';
import { BackupDefaultPage } from './components/error/BackupDefaultPage';
import { TagManagerRoot } from './components/TagManagerRoot';
import { HOME_PATH, Home } from './components/home/Home';
import { Layout } from './components/shared/Layout';
import { NotFound } from './components/error/NotFound';
import { DETALLE_PATH_PARAMS, Detalle } from './components/detalle/Detalle';
import { RESULTADO_PATH, Resultado } from './components/catalogo/Resultado';
import { LoginBoundary } from './components/header/login/LoginBoundary';
import { MoraBoundary } from './components/mora/MoraBoundary';

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ErrorBoundary backupComponent={<BackupDefaultPage />}>
        <AnalyticsRoot />
        <TagManagerRoot />
        <MoraBoundary>
          <LoginBoundary>
            <Layout>
              <Routes>
                <Route path={HOME_PATH} element={<Home />} />
                <Route path={DETALLE_PATH_PARAMS} element={<Detalle />} />
                <Route path={`${RESULTADO_PATH}/*`} element={<Resultado />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          </LoginBoundary>
        </MoraBoundary>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
export default App;
